import React from 'react';
import { InputAdornment, TextField } from '@material-ui/core';
import SearchIcon from '@mui/icons-material/Search';
import { debounce } from 'lodash';

import { useInventory } from '@services/stock';

import InventoryActions from '../../components/InventoryActions';
import InventoryFilters from '../../components/InventoryFilters';

import styles from './InventoryViewer.module.scss';

const ActionBar = ({
	shop,
	setBulkHideModal,
	setBulkUnhideModal,
	setBulkUploadModalOpen,
	setQuantityBufferModal,
	handleSearchChange,
	disabled
}) => {
	const { isLoading: isInventoryLoading, isEmpty, searchInput } = useInventory(shop.organisationId, shop.id);

	return (
		<div className={styles.actionContainer}>
			<TextField
				variant="outlined"
				className={styles.searchField}
				defaultValue={searchInput}
				onChange={debounce(handleSearchChange, 500)}
				placeholder="Search..."
				InputProps={{
					'data-testid': 'inventory-search-input',
					className: styles.searchInput,
					startAdornment: (
						<InputAdornment position="start">
							<SearchIcon className={styles.searchFieldIcon} />
						</InputAdornment>
					)
				}}
			/>
			<InventoryFilters />

			<div className={styles.actionsDropdown} data-cy="inventory-actions-dropdown">
				<InventoryActions
					setBulkHideModal={setBulkHideModal}
					setBulkUnhideModal={setBulkUnhideModal}
					setBulkUploadModalOpen={setBulkUploadModalOpen}
					setQuantityBufferModal={setQuantityBufferModal}
					disabled={isEmpty || isInventoryLoading || disabled}
				/>
			</div>
		</div>
	);
};

export default ActionBar;
